import { render } from "@/components/pages/individualWorkSupport/requirement047/Requirement047.html?vue&type=template&id=19858ae8&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement047/Requirement047.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement047/Requirement047.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement047/Requirement047.scss?vue&type=style&index=0&id=19858ae8&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19858ae8"]])

export default __exports__